export default __webpack_public_path__ + "static/media/logo.b53d7ad2.svg";